<template>
  <div class="us_module">
    <div v-for="(umItem,index) in usModule" :key="index" class="usM_item" @click="usModuleLink(index+1)">
      {{umItem.name}}
    </div>
  </div>
</template>
<script>
import { eventBus } from '../../../common/util/eventBus.js';
export default {
  data() {
    return {
      usModule: [
        { name: '公司简介' },
        { name: '领导团队' },
        { name: '视频中心' }
      ],
      busNo: 0
    };
  },
  methods: {
    usModuleLink(param) {
      this.busNoTrans(param);
      this.routerTrans(param);
    },
    busNoTrans(numbers) {
      eventBus.$emit('companyMdulePlayer', numbers);
    },
    routerTrans(numbers) {
      this.$router.push({
        name: 'company',
        params: {
          sumType: numbers
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.us_module {
  width: 100px;
  background-color: #F1F3F4;

  .usM_item {
    font-size: 16px;
    line-height: 35px;
    height: 35px;
     width: 100px;
    text-align: center;
    padding: 5px 0;
  }

  .usM_item:hover {
    background-color: #00697F;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/header/aboutUs.vue